import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RegistryApiService } from './registry-api.service';
import { IdentityUserContext } from '../models/identity-user-context.model';
import { UserTypeEnum } from '../enums/user-type.enum';

@Injectable({
  providedIn: 'root'
})
export class UserContextService {
  private nameSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  public name$: Observable<string | null> = this.nameSubject.asObservable();

  public individualUserContext?: IdentityUserContext | null;

  constructor(
    private registryAPI: RegistryApiService
  ) { }

  // Initializes the user context
  async initialize(): Promise<void> {
    this.individualUserContext = await this.getIndividualContext();
    if (this.individualUserContext) {
      this.nameSubject.next(this.individualUserContext?.entityName ?? null); //Assign the name from the context to the nameSubject
    } else {
      // If the user does not have an individual user context (support), fall back to the name of the identity user
      const identityUser = await this.registryAPI.getIdentityUser();
      this.nameSubject.next(identityUser ? `${identityUser.firstName} ${identityUser.lastName}` : null);
    }
  }

  // Retrieves the individual user context
  public async getIndividualContext(): Promise<IdentityUserContext | null> {
    const identityUserContexts = await this.registryAPI.getIdentityUserContexts();
    return identityUserContexts.find(context => context.userType == UserTypeEnum.Individual) || null;
  }
}
